import { Component, OnInit, ElementRef, ViewChild } from '@angular/core'
import { Router, ActivatedRoute } from '@angular/router'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { DateTextFieldValidator } from '../../../validations/date-text-field.validator'
import { DataEntryStep1 } from '../../models/data-entry-step1'
import { ValidatedRadioButtonModel } from '../../../validations/validated-radio-button-group.component'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { PortalGlobals } from '../../../portalglobals'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import { CurrentUserGateway } from '../../../common/gateways/current-user-gateway'
import { CurrentUser } from '../../../common/models/current-user'
import { OrgFeatureSettingValue } from '../../../bak-questions/models/bakquestions'
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid'
import { jqxDropDownButtonComponent } from 'jqwidgets-ng/jqxdropdownbutton'
import { stcobModel } from '../../models/stcob-model'
import { GoodStandingModel } from '../../../common/models/good-standing-model'
import { EnrollmentHeader } from '../../models/EnrollmentHeader'
import { EnrollmentField, EnrollmentFieldCodes } from '../../models/enrollment-field'
import { ExternalEnrollmentFieldCodes } from '../../models/ExternalEnrollmentFieldCodes'
import * as moment from 'moment'
import { BeneficiaryInfo } from '../../models/enrollments'
import { DatePipe } from '@angular/common'
import { AddressDB } from '../../../user-management/models/address'
import { ValidatedSelectOptionModel as State } from '../../../validations/validated-dropdown.component'
import { StateGateway } from '../../../common/gateways/state-gateway'
import { LicenseApptGateway } from '../../../user-management/gateways/license-appt-gateway'
import { GroupPlanComponent } from '../common/group-plans.component'
import { EnrollmentCacheData } from '../../models/EnrollmentCacheData'
import { AuthService } from '../../../auth/auth-service'

@Component({
    selector: 'ExternalAgentStep1',
    templateUrl: 'external-agent-step1.html',
    providers: [DatePipe]
})
export class ExternalAgentStep1 implements OnInit {
    notBlankValidator = new NotBlankGenericFieldValidator()
    validatedDate = new DateTextFieldValidator()
    dataEntryStep1 = {} as DataEntryStep1
    @ViewChild(GroupPlanComponent) private childGroup: GroupPlanComponent

    isValidAgent: boolean
    isFormValid: boolean
    selFaxContactType: string
    dateofReceiptInvalid: boolean
    ContactTypeInvalid: boolean
    showMLPAP: boolean
    public optionrbConactType: ValidatedRadioButtonModel[] = []
    optionrbEnrollmentMethod: ValidatedRadioButtonModel[] = []
    optionrbScope: ValidatedRadioButtonModel[] = []
    selEnrollmentMethod: string
    ErrorMessages: any[]
    enrollment: EnrollmentViewModel = {} as EnrollmentViewModel
    enrollmentCacheData: EnrollmentCacheData = {} as EnrollmentCacheData
    agentUserName: string
    hasError: boolean
    currentUser: CurrentUser
    showAdminError: boolean = false
    isSingle: boolean = true
    CUID: string
    AgentID: string
    featureName: string
    settingName: string
    OrgSetting: OrgFeatureSettingValue[]
    isCommisionable: boolean
    isVisibleAgentId: boolean
    noGrpPlan: boolean
    stcobDetails: stcobModel[] = []
    loading: boolean = false
    onchangeOrgId: string
    ExtAgentID: string
    rowNum: number
    selSOA: string
    SEPReasonCodeList: any[]
    @ViewChild('myGrid') myGrid: jqxGridComponent
    @ViewChild('myDropDownButton') myDropDownButton: jqxDropDownButtonComponent
    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef
    goodStandingValues: GoodStandingModel = {} as GoodStandingModel
    enrollmentHeader: EnrollmentHeader = {} as EnrollmentHeader
    benefitaryModel: BeneficiaryInfo = {} as BeneficiaryInfo
    residentialAddress: AddressDB = {} as AddressDB
    mailingAddress: AddressDB = {} as AddressDB
    states: State[] = [] as State[]
    SOANotIncludedMail: boolean
    insCo: string
    SkipRTSCheck: boolean = false
    source: any = {
        localdata: this.stcobDetails,
        datafields: [
            { name: 'GroupName', type: 'string' },
            { name: 'PrimaryCarrier', type: 'string' },
            { name: 'PrimaryAccount', type: 'string' },
            { name: 'PrimaryGroup', type: 'string' },
            { name: 'SecondaryCarrier', type: 'string' },
            { name: 'SecondaryAccount', type: 'string' },
            { name: 'SecondaryGroup', type: 'string' },
            { name: 'PlanTypeShortName', type: 'string' },
            { name: 'PlanTypeName', type: 'string' },
            { name: 'CAGTypeShortName', type: 'string' },
            { name: 'CAGTypeName', type: 'string' },
            { name: 'GroupFlag', type: 'string' },
            { name: 'OptOutFlag', type: 'string' },
            { name: 'STCOBFlag', type: 'string' },
            { name: 'PBP', type: 'string' },
            { name: 'RxEnrollXREFID', type: 'string' },
            { name: 'CUID', type: 'string' },
            { name: 'CAGID', type: 'string' }
        ],
        datatype: 'array'
    }

    dataAdapter: any = new jqx.dataAdapter(this.source)

    columns: any[] = [
        { text: 'Group Name', datafield: 'GroupName', width: 300 },
        { text: 'Primary Carrier', datafield: 'PrimaryCarrier', width: 100 },
        { text: 'Primary Account', datafield: 'PrimaryAccount', width: 140 },
        { text: 'Primary Group', datafield: 'PrimaryGroup', width: 140 },
        { text: 'Secondary Carrier', datafield: 'SecondaryCarrier', width: 100 },
        { text: 'Secondary Account', datafield: 'SecondaryAccount', width: 140 },
        { text: 'Secondary Group', datafield: 'SecondaryGroup', width: 140 },
        { text: 'CUID', datafield: 'CUID', width: 100 },
        { text: 'CAGID', datafield: 'CAGID', width: 100 }
    ]

    ready = (): void => {}

    constructor(
        private router: Router,
        private _enrollementGateway: EnrollmentGateway,
        private _authService: AuthService,
        public _global: PortalGlobals,
        private _currentUserGateway: CurrentUserGateway,
        private route: ActivatedRoute,
        private pipe: DatePipe,
        private _stateGateway: StateGateway,
        private _licenseAppGateway: LicenseApptGateway
    ) {
        this.currentUser = {} as CurrentUser
        this.optionrbEnrollmentMethod.push(
            { value: 'Mail', htmlLabel: 'I received a paper application in the mail' },
            { value: 'Paper', htmlLabel: 'I completed a paper application in a face to face meeting with the beneficiary' },
            { value: 'EDIP', htmlLabel: 'I am entering the application directly in the Portal' }
        )
        this.optionrbScope.push(
            { value: 'ScopeIncluded', htmlLabel: 'A Scope of Appointment is included with this enrollment form' },
            {
                value: 'ScopeNotIncluded',
                htmlLabel:
                    'Scope of Appointment was NOT completed because the agent did not have an individual or one-on-one marketing appointment (whether in person, telephonically or otherwise) with the applicant.'
            }
        )
        this.selSOA = ''
        this.SEPReasonCodeList = [] as any[]
        this.SOANotIncludedMail = false
    }

    ngOnInit() {
        this.route.params.subscribe((params) => {
            if (!params['id'] && !(params['ak'] && params['eid'])) {
                //For Extnernal access
                this._authService.isAuthorization('external-agent')
            } else {
                if (params['id'] === '1') {
                    //For Single  Group Enrollment.
                }
            }
        })

        //Remove session object
        if (sessionStorage.getItem('EnrollmentCache') != null) {
            sessionStorage.removeItem('EnrollmentCache')
        }

        this.noGrpPlan = false
        if (this._global.currentUser === undefined || this._global.currentUser.insuranceCompanyShortName === undefined) {
            this._currentUserGateway.getCurrentUser().subscribe((user) => {
                if (user != null) {
                    this._global.currentUser = user
                    this.insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
                    this.setPageData()
                }
            })
        } else {
            this.insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
            this.setPageData()
        }
    }

    isAuthorization(pageRoute: string) {
        let route = location.href
        var routes = route.split('#')
        route = routes[1]
        let planyear = this._global.selectedPlanYear
        this.currentUser = JSON.parse(localStorage.getItem('UserSessionContext')!)
        if (planyear == undefined || planyear == 0) {
            if (localStorage.getItem('PLANYEAR') != undefined && localStorage.getItem('PLANYEAR') != null) {
                planyear = Number(localStorage.getItem('PLANYEAR'))
            }
        }
        if (planyear == 0) {
            return
        } else {
            if (planyear >= this._global.Planyear2025) {
                if (!(this.currentUser.IsDataEntrySpecialist || this.currentUser.IsRDCDataEntry)) {
                    if (route.includes(pageRoute)) {
                        this.router.navigate(['/' + this.currentUser.insuranceCompanyShortName.toLowerCase() + '/home'])
                    }
                }
            }
        }
    }

    setSTCOBData(row: any) {
        this.enrollment.PLANTYPE = row['PBP']
        this.enrollment.STCOBGROUPNAME = row['GroupName']
        if (row['STCOBFlag'] === 'Y') {
            this.enrollment.GROUP = row['SecondaryGroup']
            this.enrollment.CARRIER = row['SecondaryCarrier']
            this.enrollment.ACCOUNT = row['SecondaryAccount']
            this.enrollment.ISSTCOB = true
            this.enrollment.CHANNELID = row['RxEnrollXREFID']
            this.enrollment.CUID = row['CUID']
        } else {
            this.enrollment.GROUP = row['PrimaryGroup']
            this.enrollment.CARRIER = row['PrimaryCarrier']
            this.enrollment.ACCOUNT = row['PrimaryAccount']
            this.enrollment.ISSTCOB = false
            this.enrollment.CHANNELID = row['RxEnrollXREFID']
            this.enrollment.CUID = row['CUID']
        }
        this.enrollment.SINGLEGRPNAME =
            this.enrollment.STCOBGROUPNAME + '-' + this.enrollment.CARRIER + '-' + this.enrollment.ACCOUNT + '-' + this.enrollment.GROUP
    }

    setPageData() {
        if (!this._global.currentUser.IsAgent) {
            this.isVisibleAgentId = true
        }
        if (this._global.currentUser.userProfileName !== undefined && !this._global.currentUser.IsEnoller) {
            this.agentUserName = this._global.currentUser.userProfileName
        } else {
            this.agentUserName = ''
        }
        this.route.params.subscribe((params) => {
            if (params['id'] && params['id'] === '1' && !params['from']) {
                this.enrollment = {} as EnrollmentViewModel
            } else {
                this.enrollment = this._enrollementGateway.getEnrollmentViewModel()
                this.enrollment.isPhoneEnrollment = false
            }
        })

        if (this.enrollment.ISBACK !== undefined) {
            if (!this.enrollment.ISBACK) {
                this.enrollment = {} as EnrollmentViewModel
            } else {
                this.dataEntryStep1.DateofReceipt = this.enrollment.DATEOFRECEIPT
                this.dataEntryStep1.DataSource = this.enrollment.AGENTDEX
                this.dataEntryStep1.SOA = this.enrollment.SOA

                this.selEnrollmentMethod = this.dataEntryStep1.DataSource
                this.selSOA = this.dataEntryStep1.SOA

                this.AgentID = this.enrollment.AGENTID
                this.dataEntryStep1.AgentID = this.enrollment.AGENTNAME
            }
        } else {
            this.dataEntryStep1.DateofReceipt = this.enrollment.DATEOFRECEIPT
            this.dataEntryStep1.DataSource = this.enrollment.AGENTDEX

            this.dataEntryStep1.DataSource = this.enrollment.AGENTDEX
            this.selEnrollmentMethod = this.dataEntryStep1.DataSource
            this.dataEntryStep1.SOA = this.enrollment.SOA
            this.AgentID = this.enrollment.AGENTID
            this.dataEntryStep1.AgentID = this.enrollment.AGENTNAME
        }

        this.featureName = 'FMO Settings'
        this.settingName = 'Commissionable'
        this.dataEntryStep1.AgentID = this.agentUserName
        this.enrollment.AGENTNAME = this.agentUserName
        this.showMLPAP = false
        this.isValidAgent = false
        this.hasError = false
        this.ErrorMessages = [] as any[]

        if (this.enrollment.SAMEADDRESS !== undefined && this.enrollment.SAMEADDRESS !== true) this.enrollment.ISSINGLEGROUP = false

        this.enrollment.FORMNAME = 'EXTERNAL'
        this.route.params.subscribe((params) => {
            if (params['ak'] !== undefined && params['eid'] !== undefined && params['from'] == 'external') {
                this.enrollment.ACCESSKEY = params['ak']
                this.enrollment.ENROLLMENTID = params['eid']
                this.enrollment.ISEXTERNALAGENT = true
                this.enrollment.FORMNAME = 'EXTERNALSMS'
                this.setExternalData()
            } else {
                this.route.params.subscribe((params) => {
                    if (!params['id'] && !(params['ak'] && params['eid'])) {
                        //this.enrollment = {} as EnrollmentViewModel
                        this.enrollment.FORMNAME = 'EXTERNAL'
                        this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
                    } else {
                        if (params['id'] === '1') {
                            this.isSingle = false
                            this.enrollment.ISSINGLEGROUP = true
                            // removed as per new requirement
                            // this.CheckCommissionable()
                            this.isVisibleAgentId = true
                            this.enrollment.AGENTORGID = Number(this._global.currentUser.orgId) //models
                            //this.getSTCOBDetails(Number(this._global.currentUser.orgId))
                            this.enrollment.FORMNAME = 'SINGLEGROUP'
                            if (this._global.currentUser.IsDataEntryGroupSpecialist) {
                                this._enrollementGateway.getEGWPUserProfileName().subscribe(
                                    (model: string) => {
                                        if (model !== undefined && model !== null && model.length !== 0) {
                                            this.dataEntryStep1.AgentID = model
                                            this.agentUserName = model
                                        }
                                    },
                                    (err) => {}
                                )
                            }
                        }
                        //if (!params['ak'] && !params['eid']) {
                        //    this.enrollment.ACCESSKEY = params['ak']
                        //    this.enrollment.ENROLLMENTID = params['eid']
                        //    this.enrollment.ISEXTERNALAGENT = true
                        //}
                        //if (params['id'] === undefined || params['id'] !== 'SameAddress') {

                        //    this.enrollment = {} as EnrollmentViewModel
                        //    this.enrollment.ISSINGLEGROUP = false
                        //    this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
                        //}
                    }
                })
            }
        })
    }
    /*
    CheckCommissionable() {
        this.loading = true
        this._enrollementGateway.getOrgAppFeatureSettingValues(parseInt(this._global.currentUser.orgId), this.featureName, this.settingName).subscribe(
            (model: OrgFeatureSettingValue[]) => {
                if (model != null) {
                    this.OrgSetting = model
                    if (this.OrgSetting !== undefined) {
                        if (this.OrgSetting[0].SettingValue !== undefined && this.OrgSetting[0].SettingValue === 'YES') {
                            this.isCommisionable = true
                        }
                        else {
                            this.isCommisionable = false
                        }
                        //if (this.isCommisionable && !this._global.currentUser.IsAgent) {
                        //    this.isVisibleAgentId = true
                        //}
                        //else {
                        //    this.isVisibleAgentId = true
                        //}
                    }
                }
                this.loading = false
            },
            (err) => {
                this.loading = false
            })
    }
    */

    onContinue(): void {
        this.hasError = false
        this.ErrorMessages = [] as any[]

        this.validateAgent()
        //this.getCuidForUserName()
        //if (this.isCommisionable && this.enrollment.ISSINGLEGROUP) {
        //    this.getCuidForUserName()
        //}
        //else if (!this.enrollment.ISSINGLEGROUP) {
        //    this.validateAgent()

        //}
        //else if (!this.isCommisionable && this.enrollment.ISSINGLEGROUP) {
        //    this.getCuidForUserName()
        //}
    }

    validateAgent() {
        this.showAdminError = false
        this.ExtAgentID = ''

        if (sessionStorage.getItem('SkipGSCheck') != null) {
            sessionStorage.removeItem('SkipGSCheck')
        }

        if (this._global.currentUser !== undefined && this._global.currentUser !== null) {
            if (
                this._global.currentUser.AgreementVersionNumber !== null &&
                this._global.currentUser.AgreementVersionNumber.trim() === '40' &&
                this._global.currentUser.IsAgent
            ) {
                this.SkipRTSCheck = true
                sessionStorage.setItem('SkipGSCheck', 'Yes')
            }
        }

        if (this._global.currentUser.userProfileName === this.dataEntryStep1.AgentID && sessionStorage.getItem('GoodStandingParams') !== null) {
            this.goodStandingValues = JSON.parse(sessionStorage.getItem('GoodStandingParams')!)
            if (
                this.goodStandingValues !== undefined &&
                this.goodStandingValues != null &&
                !this.goodStandingValues.GoodStandingStatus &&
                !this.SkipRTSCheck
            ) {
                this.hasError = true
                if (!this.goodStandingValues.CurriculumStatus) {
                    this.ErrorMessages.push(this.dataEntryStep1.AgentID + ' has not passed training for ' + this._global.selectedPlanYear + '<br/>')
                }
                if (!this.goodStandingValues.BackgroundCheckStatus) {
                    this.ErrorMessages.push(this.dataEntryStep1.AgentID + ' background check not approved.<br/>')
                }
                if (!this.goodStandingValues.LicenseStatus) {
                    this.ErrorMessages.push(this.dataEntryStep1.AgentID + ' does not have any valid license.<br/>')
                }
                return
            }
        }
        this.loading = true
        if (this.enrollment.ISSINGLEGROUP !== undefined && this.enrollment.ISSINGLEGROUP) {
            this._enrollementGateway.isSingleGroupValid(this.dataEntryStep1.AgentID).subscribe(
                (validAgentModel) => {
                    this.ValidateAgent(validAgentModel)
                },
                (err) => {
                    this.loading = false
                }
            )
        } else {
            this._enrollementGateway.isExternalValid(this.dataEntryStep1.AgentID).subscribe(
                (validAgentModel) => {
                    this.ValidateAgent(validAgentModel)
                },
                (err) => {
                    this.loading = false
                }
            )
        }
    }

    ValidateAgent(validAgentModel: any) {
        let isagentvalid = true
        this.ErrorMessages = [] as any[]

        if (validAgentModel !== undefined && validAgentModel.errorMessage !== '' && validAgentModel.errorMessage !== null) {
            this.ErrorMessages.push(validAgentModel.errorMessage)
            isagentvalid = false
        }
        this.isValidAgent = isagentvalid
        if (!this.isValidAgent) {
            this.hasError = true
        } else {
            this.hasError = false
            this.CUID = validAgentModel.CUID != null ? validAgentModel.CUID : this.enrollment.CUID
            this.enrollment.AGENTORGID = validAgentModel.AgentOrgId
            this.enrollment.AGENTDETAILS = validAgentModel.CurrentUser
            this.AgentID = String(validAgentModel.agentID)
        }

        if (!this.isValidAgent) {
            this.loading = false
            this.focusableEleTop.nativeElement.focus()
            return
        } else {
            if (!validAgentModel.CurrentUser.IsAdminOrAgent) {
                if (this.enrollment.ISSINGLEGROUP != undefined && this.enrollment.ISSINGLEGROUP) {
                    if (
                        validAgentModel.CurrentUser.IsImAdminOrAbove ||
                        validAgentModel.CurrentUser.IsSuperAdminSMA ||
                        validAgentModel.CurrentUser.IsSuperAdminSMM ||
                        validAgentModel.CurrentUser.IsGuruAdmin ||
                        validAgentModel.CurrentUser.IsSuperAdminAdmin ||
                        (validAgentModel.CurrentUser.IsAdmin && !validAgentModel.CurrentUser.isGroupAdmin)
                    ) {
                        this.ExtAgentID = this.dataEntryStep1.AgentID
                        this.showAdminError = true
                        this.isValidAgent = false
                        this.loading = false
                        return
                    }
                } else {
                    if (
                        validAgentModel.CurrentUser.IsImAdminOrAbove ||
                        validAgentModel.CurrentUser.IsSuperAdminSMA ||
                        validAgentModel.CurrentUser.IsSuperAdminSMM ||
                        validAgentModel.CurrentUser.IsGuruAdmin ||
                        validAgentModel.CurrentUser.IsSuperAdminAdmin ||
                        validAgentModel.CurrentUser.IsAdmin
                    ) {
                        this.ExtAgentID = this.dataEntryStep1.AgentID
                        this.showAdminError = true
                        this.isValidAgent = false
                        this.loading = false
                        return
                    }
                }
            }
            if (
                this._global.currentUser.IsEnoller ||
                this._global.currentUser.isOrganizationalAdmin ||
                this._global.currentUser.isOrganizationalManager ||
                this._global.currentUser.IsAdminOrAgent
            ) {
                if (!validAgentModel.CurrentUser.IsAgent && !validAgentModel.CurrentUser.IsAdminOrAgent) {
                    this.hasError = true
                    this.isValidAgent = false
                    this.loading = false
                    this.ErrorMessages.push(
                        'An enrollment cannot be entered for Agent ' +
                            this.dataEntryStep1.AgentID +
                            " because Enrollments can't be done for " +
                            validAgentModel.CurrentUser.roleCode
                    )
                    this.focusableEleTop.nativeElement.focus()
                    return
                }
            }
            if (validAgentModel.CurrentUser.isCallCenterRepresentative || validAgentModel.CurrentUser.isCallCenterAdmin) {
                this.ErrorMessages.push(this.dataEntryStep1.AgentID + ' is not valid for enrollment.<br/>')
                this.hasError = true
                this.isValidAgent = false
                this.loading = false
                this.focusableEleTop.nativeElement.focus()
                return
            }

            //Skip GS check if agent if agrmeent ver=40
            if (
                validAgentModel.CurrentUser.AgreementVersionNumber !== null &&
                validAgentModel.CurrentUser.AgreementVersionNumber.trim() === '40' &&
                validAgentModel.CurrentUser.IsAgent
            ) {
                this.SkipRTSCheck = true
                sessionStorage.setItem('SkipGSCheck', 'Yes')
            }

            this.enrollment.AGENTDEX = this.dataEntryStep1.DataSource
            this.enrollment.DEX = 'AGNTP'
            this.enrollment.SOA = this.dataEntryStep1.SOA
            this.enrollment.AGENTID = this.AgentID
            this.enrollment.AGENTNAME = this.dataEntryStep1.AgentID
            this.enrollment.ADMINID = this._global.currentUser.userProfileId
            this.enrollment.CUID = this.CUID
            this.enrollment.USERPROFILEID = this._global.currentUser.userProfileId
            this.enrollment.USERNAME = this._global.currentUser.userProfileName
            this.enrollment.STEEREDIND = true
            this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
            this.loading = false

            if (this.enrollment.FORMNAME === 'SINGLEGROUP') {
                this.enrollmentCacheData.ISSINGLEGROUP = true
                this.enrollmentCacheData.ISSTCOB = this.enrollment.ISSTCOB
                this.enrollmentCacheData.SINGLEGRPNAME = this.enrollment.SINGLEGRPNAME
                this.enrollmentCacheData.AgentName = this.enrollment.AGENTNAME
                this.enrollmentCacheData.AgentID = this.enrollment.AGENTID
                this.enrollmentCacheData.AdminID = this.enrollment.ADMINID
                this.enrollmentCacheData.AgentOrgID = this.enrollment.AGENTORGID
                this.enrollmentCacheData.PLANTYPENAME = this.enrollment.PLANTYPENAME
                this.enrollmentCacheData.USERNAME = this.enrollment.USERNAME
                this.enrollmentCacheData.ACCESSKEY = this.enrollment.ACCESSKEY
                this.enrollmentCacheData.ENROLLMENTID = this.enrollment.ENROLLMENTID
                this.enrollmentCacheData.PlanYear = this._global.selectedPlanYear
                this.enrollmentCacheData.FORMNAME = this.enrollment.FORMNAME

                sessionStorage.setItem('EnrollmentCache', JSON.stringify(this.enrollment))
            }

            if (this.insCo === undefined || this.insCo === null) {
                this.insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
            }
            this.router.navigate(['/' + this.insCo + '/enrollment/external-agent/Step2'])
        }
        this.loading = false
    }
    /*
    getCuidForUserName() {
        this.loading = true
        this._enrollementGateway.isValidAgent(this.dataEntryStep1.AgentID)
            .subscribe(
            (validAgentModel) => {
                if (validAgentModel !== undefined && validAgentModel.errorMessage !== '' && validAgentModel.errorMessage !== null) {
                    this.ErrorMessages.push(validAgentModel.errorMessage)
                    this.focusableEleTop.nativeElement.focus();
                    this.hasError = true
                    return
                }
                else {
                    this.hasError = false
                    this.CUID = validAgentModel.CUID
                    this.enrollment.AGENTORGID = validAgentModel.AgentOrgId
                    this.enrollment.AGENTDETAILS = validAgentModel.CurrentUser
                    this.AgentID = String(validAgentModel.agentID)
                    this.enrollment.AGENTDEX = this.dataEntryStep1.DataSource
                    this.enrollment.DEX = 'AGNTP'
                    this.enrollment.SOA = this.dataEntryStep1.SOA
                    this.enrollment.AGENTID = this.AgentID
                    this.enrollment.AGENTNAME = this.dataEntryStep1.AgentID
                    this.enrollment.CUID = this.CUID
                    this.enrollment.USERPROFILEID = this._global.currentUser.userProfileId
                    this.enrollment.USERNAME = this._global.currentUser.userProfileName
                    this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
                    this.loading = false
                    this.router.navigate(['/' + this.insCo + '/enrollment/external-agent/Step2'])
                }
                this.loading = false
            },
            (err) => {
                this.loading = false
            })


    }
    */

    formSubmit(): void {
        if (this.validateForm()) {
            console.log('Errors: ')
            this.hasError = true
            this.focusableEleTop.nativeElement.focus()
        } else {
            console.log('valid: ')
            this.onContinue()
        }
    }

    validateForm(): boolean {
        this.hasError = false
        this.ErrorMessages = [] as any[]
        this.enrollment.AGENTDEX = this.dataEntryStep1.DataSource
        this.enrollment.SOA = this.dataEntryStep1.SOA
        this.enrollment.AGENTID = this.dataEntryStep1.AgentID

        if (this.enrollment.ISSINGLEGROUP === true) {
            if (this.enrollment.STCOBGROUPNAME === undefined || this.enrollment.STCOBGROUPNAME === null || this.enrollment.STCOBGROUPNAME === '') {
                this.ErrorMessages.push('Group Name is required')
                this.hasError = true
            }
        }

        if (this.enrollment === undefined) {
            this.ErrorMessages.push('Enrollment Method is Required.')
            this.ErrorMessages.push('Scope of Appointment is Required.')
            //this.ErrorMessages.push('Agent ID is Required')
        } else {
            if (this.enrollment.AGENTDEX === undefined || this.enrollment.AGENTDEX === '') {
                this.ErrorMessages.push('Enrollment Method is Required.')
                this.hasError = true
            }
            if (!this.enrollment.ISSINGLEGROUP) {
                if (this.enrollment.SOA === undefined || this.enrollment.SOA === '') {
                    this.ErrorMessages.push('Scope of Appointment is Required.')
                    this.hasError = true
                }
            }

            if (this.enrollment.AGENTID === undefined || this.enrollment.AGENTID === '' || this.enrollment.AGENTID === null) {
                this.ErrorMessages.push('Agent ID is Required')
                this.hasError = true
            } else {
                if (this.isVisibleAgentId) {
                    let checkAgentID = this.enrollment.AGENTID,
                        regexAgentIDVal = new RegExp('^[a-zA-_Z0-9-@]*$')
                    let isAgentIDValid = regexAgentIDVal.test(checkAgentID)
                    if (!isAgentIDValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Agent ID is invalid')
                    }
                }
            }
        }

        return this.hasError
    }

    selectedRbtn(event: any) {
        this.dataEntryStep1.DataSource = event
        if (event === 'EDIP')
            alert(
                'YOUR CLIENT SIGNATURE IS REQUIRED. After you complete the online enrollment, please print out the document and have your client sign it.'
            )
    }

    updateAgentGroup() {
        if (this.enrollment.ISSINGLEGROUP) {
            this.hasError = false
            this.showAdminError = false
            this.ErrorMessages = [] as any[]
            //this.rowNum = this.myGrid.getselectedrowindex()
            ///this.myGrid.unselectrow(this.rowNum)
            this.enrollment.SINGLEGRPNAME = ''
            this.enrollment.STCOBGROUPNAME = ''
            if (
                this.dataEntryStep1.AgentID !== undefined &&
                this.dataEntryStep1.AgentID !== '' &&
                this.dataEntryStep1.AgentID !== null &&
                this.dataEntryStep1.AgentID !== ''
            ) {
                this.loading = true
                this._enrollementGateway.getOrgIdByUserName(this.dataEntryStep1.AgentID).subscribe(
                    (model: string) => {
                        if (model !== undefined && model !== null && model.length !== 0) {
                            this.hasError = false
                            this.onchangeOrgId = model
                            this.enrollment.AGENTORGID = Number(this.onchangeOrgId) //models
                            this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
                            //this.getSTCOBDetails(Number(this.onchangeOrgId))

                            if (this.childGroup.IsPlanvisible) {
                                //Refresh list based on State Change
                                this.childGroup.getSTCOBDetails()
                            }

                            this.loading = false

                            return
                        } else {
                            this.ErrorMessages.push('Failed to get User Profile by User Profile Name')
                            this.focusableEleTop.nativeElement.focus()
                            this.hasError = true
                            this.loading = false
                        }
                    },
                    (err) => {
                        this.loading = false
                    }
                )
            }
        }
    }
    onKeyDown(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.formSubmit()
        }
    }

    setExternalData() {
        this.enrollmentHeader.EnrollmentID = this.enrollment.ENROLLMENTID
        this.enrollmentHeader.accesskey = this.enrollment.ACCESSKEY

        //Service call to set external data
        this.loading = true
        this._enrollementGateway.getEnrollmentHeader(this.enrollmentHeader).subscribe(
            (model: EnrollmentField[]) => {
                this.enrollment.beneficiaryInfo = {} as BeneficiaryInfo
                this.benefitaryModel = {} as BeneficiaryInfo

                this.SEPReasonCodeList.push(
                    { value: '125', code: 'NewMedicare' },
                    { value: '126', code: 'ReturnUSA' },
                    { value: '128', code: 'Now65' },
                    { value: '200', code: 'NewOptin' },
                    { value: '201', code: 'EmployerCoverage' },
                    { value: '203', code: 'StatedataEntryStep1Premium' },
                    { value: '204', code: 'NoExtraHelp' },
                    { value: '205', code: 'MovedLTC' },
                    { value: '206', code: 'LeftPACE' },
                    { value: '207', code: 'LostCoverage' },
                    { value: '211', code: 'StatePAP' },
                    { value: '213', code: 'LeftMedigap' },
                    { value: '214', code: 'JoinedMedicareAdv' },
                    { value: '215', code: 'Other' },
                    { value: '218', code: 'Disenrolling' },
                    { value: '219', code: 'EndContract' },
                    { value: '221', code: 'NoSpecialNeedsPlan' },
                    { value: '222', code: 'NoticeEligible' },
                    { value: '223', code: 'LostPartB' }
                )

                for (let i = 0; i < model.length; i++) {
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.DEX) {
                        this.selEnrollmentMethod = model[i].FieldValue
                        this.dataEntryStep1.DataSource = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.SOA) {
                        if (model[i].FieldValue !== undefined && model[i].FieldValue !== null) {
                            if (model[i].FieldValue.toUpperCase() === 'YES') {
                                this.selSOA = 'ScopeIncluded'
                                this.dataEntryStep1.SOA = 'ScopeIncluded'
                            } else {
                                this.selSOA = 'ScopeNotIncluded'
                                this.dataEntryStep1.SOA = 'ScopeNotIncluded'
                            }
                        }
                    }

                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.ACCHOLDERNAME) {
                        this.enrollment.ACCHOLDERNAME = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.ELECTION) {
                        if (model[i].FieldValue === 'S') {
                            this.enrollment.ELECTION = 'Special'
                        } else if (model[i].FieldValue === 'I') {
                            this.enrollment.ELECTION = 'FirstTime'
                        } else {
                            this.enrollment.ELECTION = 'OpenEnrollment'
                        }
                        //  this.periodSelected = this.enrollment.ELECTION
                    }
                    //delete
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.RELCD) {
                        this.enrollment.RELCD = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.PLANTYPE) {
                        if (model[i].FieldValue === 'C') {
                            this.enrollment.PLANTYPE = 'CHOICE'
                        } else if (model[i].FieldValue === 'P') {
                            this.enrollment.PLANTYPE = 'PLUS'
                        } else if (model[i].FieldValue === 'S') {
                            this.enrollment.PLANTYPE = 'SMARTRX'
                        } else {
                            this.enrollment.PLANTYPE = model[i].FieldValue
                        }
                    }
                    if (this.enrollment.FORMNAME !== 'EXTERNAL') {
                        if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPDT) {
                            this.benefitaryModel.applicationDate = new Date(moment(model[i].FieldValue).format('MM/DD/YYYY'))
                        }
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.EFFDT) {
                        this.benefitaryModel.effectiveEnrollmentDate = new Date(moment(model[i].FieldValue).format('MM/DD/YYYY'))
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPFN) {
                        this.benefitaryModel.firstName = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPLN) {
                        this.benefitaryModel.lastName = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.SUFFIX) {
                        this.benefitaryModel.suffixName = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPMI) {
                        this.benefitaryModel.middleInitial = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.TITLE) {
                        this.benefitaryModel.title = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.HICN) {
                        this.benefitaryModel.medicareId = model[i].FieldValue.toString().toUpperCase()
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.MEDA) {
                        if (model[i].FieldValue !== undefined && model[i].FieldValue !== '') {
                            this.benefitaryModel.medicarePartAEffectiveDate = new Date(moment(model[i].FieldValue).format('MM/DD/YYYY'))
                        } else {
                            this.benefitaryModel.medicarePartAEffectiveDate = null
                            this.enrollment.beneficiaryInfo.medicarePartAEffectiveDate = null
                        }
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.MEDB) {
                        if (model[i].FieldValue !== undefined && model[i].FieldValue !== '') {
                            this.benefitaryModel.medicarePartBEffectiveDate = new Date(moment(model[i].FieldValue).format('MM/DD/YYYY'))
                        } else {
                            this.benefitaryModel.medicarePartBEffectiveDate = null
                            this.enrollment.beneficiaryInfo.medicarePartBEffectiveDate = null
                        }
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPDOB) {
                        let myFormattedDate: any
                        this.pipe = new DatePipe('en-US')
                        myFormattedDate = this.pipe.transform(model[i].FieldValue, 'MM/dd/yyyy')
                        this.benefitaryModel.dateOfBirth = myFormattedDate
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPPHONE) {
                        this.benefitaryModel.primaryPhone = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPGEN) {
                        this.benefitaryModel.gender = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.CELLPHONE) {
                        this.benefitaryModel.cellPhone = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.EOB) {
                        if (
                            model[i].FieldValue !== undefined &&
                            (model[i].FieldValue.toUpperCase() === 'EEOB' || model[i].FieldValue.toUpperCase() === 'YES')
                        ) {
                            this.enrollment.EOB = 'EEOB'
                        } else {
                            this.enrollment.EOB = 'PEOB'
                        }
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPEMAIL) {
                        this.benefitaryModel.email = model[i].FieldValue
                        this.enrollment.beneficiaryInfo.email = model[i].FieldValue
                    }

                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPADD1) {
                        this.residentialAddress.addressLine1 = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPADD2) {
                        this.residentialAddress.addressLine2 = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPCITY) {
                        this.residentialAddress.city = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPZIP) {
                        this.residentialAddress.zip = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPST) {
                        this.residentialAddress.state = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.MAILINGADDRESSISSAME) {
                        if (model[i].FieldValue !== undefined && model[i].FieldValue.toUpperCase() === 'TRUE') {
                            this.residentialAddress.sameAddress = true
                        } else {
                            this.residentialAddress.sameAddress = false
                        }
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.LTCFACILITY) {
                        this.enrollment.LTCFACILITY = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.LTCPHONE) {
                        this.enrollment.LTCPHONE = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.NOTES) {
                        this.enrollment.NOTES = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.SEPREASONCD) {
                        let selSepReasonCode = this.SEPReasonCodeList.filter((x) => x.value === model[i].FieldValue)[0]
                        if (selSepReasonCode === undefined || selSepReasonCode === null) {
                            selSepReasonCode = this.SEPReasonCodeList.filter((x) => x.code === model[i].FieldValue)[0]
                        }
                        this.enrollment.SEPREASONCD = Number(selSepReasonCode.value)
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.MAILADD1) {
                        this.mailingAddress.addressLine1 = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.MAILADD2) {
                        this.mailingAddress.addressLine2 = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.MAILCITY) {
                        this.mailingAddress.city = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.MAILST) {
                        this.mailingAddress.state = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.MAILZIP) {
                        this.mailingAddress.zip = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.PWO) {
                        if (model[i].FieldValue === 'P') {
                            this.enrollment.PWO = 'Direct Bill'
                        } else if (model[i].FieldValue === 'S') {
                            this.enrollment.PWO = 'Deduction from Social Security Check'
                        } else if (model[i].FieldValue === 'R') {
                            this.enrollment.PWO = 'Deduction from Railroad Retirement Board'
                        } else if (model[i].FieldValue === 'E') {
                            this.enrollment.PWO = 'Automatic Bank Draft Withdrawal'
                        }
                        //  this.paymentOption = this.enrollment.PWO
                    }
                    //if (model[i].FieldCode === ExternalEnrollmentFieldCodes.AGENTID) {
                    //    this.enrollment.AGENTID = model[i].FieldValue
                    //}
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.PLANYEAR) {
                        this.enrollment.PLANYEAR = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.LANG) {
                        if (model[i].FieldValue === 'E') {
                            this.enrollment.LANG = 'english'
                        } else if (model[i].FieldValue === 'S') {
                            this.enrollment.LANG = 'spanish'
                        } else {
                            this.enrollment.LANG = 'other'
                        }
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.OTHCVRG) {
                        if (model[i].FieldValue.toString().toUpperCase() === 'TRUE') {
                            this.enrollment.OTHCVRG = 'yes'
                            // this.showOtherCoverage = true
                        } else {
                            this.enrollment.OTHCVRG = 'no'
                            //  this.showOtherCoverage = false
                        }
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.LANGFORMAT) {
                        let langFormatValue = model[i].FieldValue
                        if (langFormatValue == '1') {
                            this.enrollment.accessibility = '1'
                            this.enrollment.EOB = 'PEOB'
                        } else if (langFormatValue == '2') {
                            this.enrollment.accessibility = '2'
                            this.enrollment.EOB = 'PEOB'
                        } else if (langFormatValue == '3' || langFormatValue == 'EEOB') {
                            this.enrollment.accessibility = ''
                            this.enrollment.EOB = 'EEOB'
                        } else if (langFormatValue == '4') {
                            this.enrollment.accessibility = '4'
                            this.enrollment.EOB = 'PEOB'
                        } else if (langFormatValue == '5') {
                            this.enrollment.accessibility = '1'
                            this.enrollment.EOB = 'EEOB'
                        } else if (langFormatValue == '6') {
                            this.enrollment.accessibility = '2'
                            this.enrollment.EOB = 'EEOB'
                        } else if (langFormatValue == '7') {
                            this.enrollment.accessibility = '4'
                            this.enrollment.EOB = 'EEOB'
                        } else {
                            this.enrollment.EOB = model[i].FieldValue
                        }
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.ACCOUNTNB) {
                        this.enrollment.ACCOUNTNB = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.OTHCVRGNAME) {
                        this.enrollment.OTHCVRGNAME = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.OTHCVRGID) {
                        this.enrollment.OTHCVRGID = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.OTHCVRGGRP) {
                        this.enrollment.OTHCVRGGRP = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.COBBIN) {
                        this.enrollment.COBBIN = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.COBPCN) {
                        this.enrollment.COBPCN = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.COBEFFDT) {
                        if (model[i].FieldValue !== undefined && model[i].FieldValue !== '') {
                            this.enrollment.COBEFFDT = new Date(moment(model[i].FieldValue).format('MM/DD/YYYY'))
                        } else {
                            this.enrollment.COBEFFDT = null
                        }
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.COBTERMDT) {
                        if (model[i].FieldValue !== undefined && model[i].FieldValue !== '') {
                            this.enrollment.COBTERMDT = new Date(moment(model[i].FieldValue).format('MM/DD/YYYY'))
                        } else {
                            this.enrollment.COBTERMDT = null
                        }
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.FININSTNAME) {
                        this.enrollment.FININSTNAME = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.EFTTYPE) {
                        if (model[i].FieldValue === 'S') {
                            this.enrollment.EFTTYPE = 'SAVINGS'
                        } else if (model[i].FieldValue === 'C') {
                            this.enrollment.EFTTYPE = 'CHECKING'
                        }
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.ROUTINGNB) {
                        this.enrollment.ROUTINGNB = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.SEPEFFDT) {
                        if (model[i].FieldValue !== undefined && model[i].FieldValue !== '') {
                            this.enrollment.SEPEFFDT = new Date(moment(model[i].FieldValue).format('MM/DD/YYYY'))
                        } else {
                            this.enrollment.SEPEFFDT = null
                        }
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.AUTHREPNAME) {
                        this.enrollment.AUTHREPNAME = model[i].FieldValue
                        this.enrollment.AUTHREPIND = 'Yes'
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.AUTHREPPHONE) {
                        this.enrollment.AUTHREPPHONE = model[i].FieldValue
                        this.enrollment.AUTHREPIND = 'Yes'
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.AUTHREPREL) {
                        this.enrollment.AUTHREPREL = model[i].FieldValue
                        this.enrollment.AUTHREPIND = 'Yes'
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.AUTHREPADD1) {
                        this.enrollment.AUTHREPADD1 = model[i].FieldValue
                        this.enrollment.AUTHREPIND = 'Yes'
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.AUTHREPCITY) {
                        this.enrollment.AUTHREPCITY = model[i].FieldValue
                        this.enrollment.AUTHREPIND = 'Yes'
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.AUTHREPST) {
                        this.enrollment.AUTHREPST = model[i].FieldValue
                        this.enrollment.AUTHREPIND = 'Yes'
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.AUTHREPZIP) {
                        this.enrollment.AUTHREPZIP = model[i].FieldValue
                        this.enrollment.AUTHREPIND = 'Yes'
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.AUTHREPIND) {
                        if (model[i].FieldValue !== undefined) {
                            if (model[i].FieldValue.toUpperCase() !== 'YES' || model[i].FieldValue.toUpperCase() !== 'TRUE') {
                                this.enrollment.AUTHREPIND = 'Yes'
                            } else {
                                this.enrollment.AUTHREPIND = 'No'
                            }
                        }
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.AUTHREPSIGNEDIND) {
                        if (model[i].FieldValue !== undefined) {
                            if (model[i].FieldValue.toUpperCase() === 'YES' || model[i].FieldValue.toUpperCase() === 'TRUE') {
                                this.enrollment.AUTHREPSIGNEDIND = true
                            } else {
                                this.enrollment.AUTHREPSIGNEDIND = false
                            }
                        }
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.SOANOTINCLUDEDMAIL) {
                        if (model[i].FieldValue !== undefined && model[i].FieldValue.toUpperCase() === 'YES') {
                            this.SOANotIncludedMail = true
                        } else {
                            this.SOANotIncludedMail = false
                        }
                    }
                }
                this.getAllStates()
            },
            (err) => {
                this.loading = false
            }
        )
    }

    getAllStates() {
        if (this.states !== undefined && this.states.length > 0) {
            this.setExternState()
        } else {
            this._stateGateway.getAllStates().subscribe((state) => {
                for (let i = 0; i < state.length; i++) {
                    this.states.push({ value: state[i].value, text: state[i].text })
                }
                this.setExternState()
            })
        }
    }

    setExternState() {
        let resState = this.states.filter((x) => x.text === this.residentialAddress.state)
        if (resState !== undefined && resState.length > 0) {
            this.residentialAddress.state = String(resState[0].value)
        }
        let mailState = this.states.filter((x) => x.text === this.mailingAddress.state)
        if (mailState !== undefined && mailState.length > 0) {
            this.mailingAddress.state = String(mailState[0].value)
        }
        let AuthRepSt = this.states.filter((x) => x.text === this.enrollment.AUTHREPST)
        if (AuthRepSt !== undefined && AuthRepSt.length > 0) {
            this.enrollment.AUTHREPST = String(AuthRepSt[0].value)
        }
        this.enrollment.beneficiaryInfo = this.benefitaryModel
        this.enrollment.residentialAddress = this.residentialAddress
        this.enrollment.mailingAddress = this.mailingAddress
        if (this.SOANotIncludedMail) {
            this.selEnrollmentMethod = 'Mail'
            this.dataEntryStep1.DataSource = 'Mail'

            this.selSOA = 'ScopeNotIncluded'
            this.dataEntryStep1.SOA = 'ScopeNotIncluded'
        }

        this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
        this.loading = false
    }
}
